<div class="scroll-xx table-component table-component--padded" [class.loading-timed-out]="loadingTimedOut && ready">
  <!-- loadingTimedOut -->
  @if (loadingTimedOut && ready) {
    <div class="loading-timed-out-spinner">
      <app-spinner></app-spinner>
    </div>
  }
  <table class="table">
    <thead>
      <tr>
        @for (head of heads; track head) {
          <th [ngStyle]="{'width' : head.width ? head.width : 'auto' }" class="" [class.saving]="loading || (!ready || notReady)" [class.sortable]="head.sortable" (click)="head.sortable && clickSort(head)"><div class="position-relative">{{head.name}}@if (head.sortable) {
            <i [ngClass]="getSortingClass(head)"></i>
          }</div></th>
        }
      </tr>
    </thead>
    @if ((ready && !notReady)) {
      <tbody>
        @for (item of data; track identify($i, item); let $i = $index) {
          <tr [class.active]="item[id] == selected" [class.clickable]="clickable">
            @for (head of heads; track identify($index, head)) {
              <td [class.td--mw-0]="item[head.code]?.mw0" [class.shrink]="item[head.code] && item[head.code].type === 'actions'" [class.linethrough]="item && item.linethrough && item[head.code] && head.code !== 'actions'" class="saving--pre {{(item[head.code]?.classList || '')}}" [class.saving]="loading">
                <!-- link -->
                @if (linkElement) {
                  <a (click)="false && $event.preventDefault(); clickData.emit({item: item, head: head.code})" draggable="false" [routerLink]="['./']" queryParamsHandling="merge" [queryParams]="{id: item[id]}"  class="pad">
                    <ng-container [ngTemplateOutlet]="tdData" [ngTemplateOutletContext]="{item: item, head: head, $i: $i}"></ng-container>
                  </a>
                }
                <!-- no link -->
                @if (!linkElement) {
                  <div (click)="$event.preventDefault(); clickData.emit({item: item, head: head.code})" class="pad">
                    <ng-container [ngTemplateOutlet]="tdData" [ngTemplateOutletContext]="{item: item, head: head, $i: $i}"></ng-container>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    }
    <!-- shimmer -->
    @if ((!ready || notReady)) {
      <tbody class="shimmer-body">
        @for (item of shimmerRows; track item) {
          <tr>
            <td [attr.colspan]="heads.length"><app-shimmer></app-shimmer></td>
          </tr>
        }
      </tbody>
    }
  </table>
</div>
<!-- emptystate -->
@if (!loading && data && !data.length && emptyState) {
  <div class="mt-s">
    <app-empty-state [value]="emptyState"></app-empty-state>
  </div>
}
<!-- pagination / export -->
@if ((ready && !notReady) && data && data.length) {
  <div class="row mt-l">
    <div class="col-md-4">
      <div class="d-flex justify-content-end pl-s">
        <!--  -->
      </div>
    </div>
    <div class="col-md-4">
      @if (totalRows > RPP) {
        <div class="d-flex justify-content-center" [class.saving]="loading">
          <app-pagination
            [RPP]="RPP"
            [startRow]="startRow"
            [totalRows]="totalRows"
            (startRowChange)="startRowChange.emit($event)">
          </app-pagination>
        </div>
      }
    </div>
    <div class="col-md-4 d-flex flex-row align-items-center">
      @if (exportLabel) {
        <div class="d-flex w-100 justify-content-end pr-s">
          <button (click)="clickExport.emit()" [class.disabled]="exportBusy" class="button-link fontsize-s export-btn">
            @if (!exportBusy) {
              <i class="im-icon im-icon-download"></i>
            }
            @if (exportBusy) {
              <app-inline-spinner class="mr-1"></app-inline-spinner>
            }
            <span>{{exportLabel}}</span>
          </button>
        </div>
      }
    </div>
  </div>
}


<!-- tData template -->
<ng-template #tdData let-item='item' let-head='head' let-$i="$i">
  <!-- default -->
  @if (!item[head.code] || !item[head.code].type) {
    {{head.code === 'empty' ? '' : item[head.code] | display}}
  }

  <!-- default type (with props) -->
  @if (item[head.code] && item[head.code].type === 'default') {
    <span [class.data-ellipsis]="item[head.code].ellipsis" [ngStyle]="{'color': item[head.code].color ? item[head.code].color : ''}" [class.has-stamps]="item[head.code]?.stamps?.length" [class]="item[head.code].classList">{{item[head.code].value | display}}</span>
  }

  <!-- title -->
  @if (item[head.code] && item[head.code].type === 'title') {
    <span [class.data-ellipsis]="item[head.code].ellipsis" [class.has-stamps]="item[head.code]?.stamps?.length" class="title">{{item[head.code].title}}</span>
  }

  <!-- titleSubtitle -->
  @if (item[head.code] && item[head.code].type === 'titleSubtitle') {
    <div class="d-inline-flex flex-column title-subtitle"><span class="title">{{item[head.code].title}}</span>@if (item[head.code].subtitle) {
    <span class="subtitle">{{item[head.code].subtitle}}</span>
  }</div>
}

<!-- ts -->
@if (item[head.code] && item[head.code].type === 'ts') {
  <span style="white-space: nowrap;">{{item[head.code].ts | formatTs: item[head.code].format : item[head.code].unix || false}}</span>
}

<!-- actions -->
@if (item[head.code] && item[head.code].type === 'actions') {
  @if (item[head.code].actions && item[head.code].actions.length) {
    <div class="action-button d-flex align-items-center actions position-relative" class="action-button d-flex align-items-center actions position-relative" [class.active]="helper.action === $i" (click)="helper.action === $i ? helper.action = null : helper.action = $i; $event.stopPropagation(); $event.preventDefault()">
      <i class="im-icon im-icon-actions"></i>
      <app-popover [open]="helper.action === $i" positionClass="left">
        <ul (click)="helper.action = null; $event.stopPropagation();">
          @for (action of item[head.code].actions; track identify($index, action)) {
            <li class="position-relative" appClickOutside (clickOutside)="helper.action = null" (click)="$event.preventDefault(); action.confirmDelete ? $event.stopPropagation() || popoverHelper = 'delete_' + $i : clickAction.emit({item: item, action: action.code});" [ngClass]="action.class || ''">
              @if (action.icon) {
                <i class="im-icon im-icon-{{action.icon}}"></i>
              }
              {{action.name}}
              @if (action.confirmDelete) {
                <app-confirm-delete (confirm)="clickAction.emit({item: item, action: action.code}); dismissPopover(); setActionIndex(null);" (cancel)="dismissPopover()" [open]="popoverHelper === 'delete_' + $i" positionClass="left"></app-confirm-delete>
              }
            </li>
          }
        </ul>
      </app-popover>
    </div>
  }
}

<!-- stamps -->
@if (item[head.code]?.stamps?.length) {
  <div class="stamps">
    <span class="spacer"></span>
    @for (stamp of item[head.code].stamps; track stamp) {
      <span class="stamp" [class]="stamp.class">{{stamp.value}}</span>
    }
  </div>
}
</ng-template>